import Model from './Model';
import Collection from './Collection';

export class Category extends Model {

	defaults() {
		return {
			id: null,
			name: '',
			level: null,
			isArchived: null,
			isEditOnly: null,
		};
	}

	mutations() {
		return {
			id: id => Number(id) || null,
		};
	}

	routes() {
		return {
			create: '/categories',
			fetch: '/categories/{id}',
			patch: '/categories/{id}',
			delete: '/categories/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}
}

export class Categories extends Model {

	defaults() {
		return {
			projectId: null,
			order: Array,
		};
	}

	mutations() {
		return {
			projectId: id => Number(id) || null,
		};
	}

	routes() {
		return {
			fetch: '/categories?projectId={projectId}',
			save: '/categories/reorder',
		};
	}
}

export class GetCategories extends Collection {

	defaults() {
		return {
			projectId: null,
		};
	}

	model() {
		return Category;
	}

	routes() {
		return {
			fetch: '/categories?projectId={projectId}',
		};
	}
}

export class ActiveCategories extends Collection {
	
	defaults() {
		return {
			projectId: null,
		};
	}

	model() {
		return Category;
	}

	routes() {
		return {
			fetch: '/categories?projectId={projectId}&archived=0',
		};
	}
}
